import { inject, Injectable } from '@angular/core';
import { NIASBizAPIDtosSysConfigResponse, SysConfigClientService } from '../api/v1';

@Injectable({
  providedIn: 'root',
})
export class SysConfigService {
  constructor(private sysConfigClientService: SysConfigClientService) {
    this.sysConfigClientService.sysConfigGet().subscribe((x) => (this.sysConfig = x));
  }

  private sysConfig: NIASBizAPIDtosSysConfigResponse | null = null;

  public get SysConfig() {
    return this.sysConfig;
  }
}
